import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Lodz() {
  return (
    <>
      <DisplayMaster voivodeship="Lodz" />
    </>
  );
}